<template>
    <div class="step_content" v-loading="stepLoading">
        <div class="operation_wrapper">
            <span class="step_icon border_leftT"></span>
            <span class="step_icon border_rightT"></span>
            <span class="step_icon border_leftB"></span>
            <span class="step_icon border_rightB"></span>
            <h3 class="task-name-info">任务名称：<span>{{taskName}}</span></h3>
            <div class="extract_opt_wrapper">
                <span class="step_opt_title">抽取项目</span>
                <span class="step_opt_icon border_opt_leftT"></span>
                <span class="step_opt_icon border_opt_rightT"></span>
                <span class="step_opt_icon border_opt_leftB"></span>
                <span class="step_opt_icon border_opt_rightB"></span>
                <span class="extract_info extract_info_left">进入抽取的项目共有：<el-button type="text" @click="extractPondListDialog=true">{{total}}</el-button> 个</span>
                <span class="extract_info extract_info_right">本次将抽取：<el-button type="text" @click="extractFilterDialog=true">{{extractNum}}</el-button> 个</span>
                <el-scrollbar :style="{'height':cardMinHeight,'min-height':'150px'}">
                    <el-row v-if="extractIngFlag">
                        <el-col :span="extractNum==1?18:12" :offset="extractNum==1?3:0"  v-for="i in extractNum" :key="i" style="padding: 10px">
                            <vue-seamless-scroll :data="defaultExtractPondListShuffle" class="seamless-warp" :class-option="classOption">
                                <p v-for="(item,index) in defaultExtractPondListShuffle" :key="index">{{item.projectName}}</p>
                            </vue-seamless-scroll>
                        </el-col>
                    </el-row>
                    <el-row v-if="!extractIngFlag">
                        <el-col :span="extractNum==1?18:12" :offset="extractNum==1?3:0"  v-for="(item,index) in extractResultList" :key="index" style="padding: 10px">
                            <div class="seamless-warp">
                                <p>{{item.projectName}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </el-scrollbar>
            </div>
            <br>
            <el-button type="primary" plain v-if="!extractIngFlag" class="start-extract-btn" :disabled="historyid != -1" @click="startExtract()">开始抽取</el-button>
            <el-button type="primary" plain v-if="extractIngFlag" @click="getExtractResult(true)">停止</el-button>
            <br>
            <span></span>
            <el-button type="text" style="margin-top: 10px" @click="showExtractResult(true)" :disabled="historyid == -1">查看抽取结果</el-button>
        </div>
        <div class="btn_wraper">
            <p class="supervisionNameInfo">监督检查单位：{{supervisionIdsName}}</p>
            <el-tooltip class="item" popper-class="bigScreenPopper" :visible-arrow="false" effect="light" placement="top-start">
                <div slot="content">
                    {{supervisionIdsName}}
                </div>
                <el-button type="text" style="float:right"> 更多> </el-button>
            </el-tooltip>

            <el-button @click="prevStep()" :disabled="extractIngFlag" plain>上一步</el-button>
            <el-button type="primary" @click="nextStep()" :disabled="historyid == -1" plain>下一步</el-button>
        </div>

        <el-dialog width="80%" :title="'本次随机抽取数量为：'+ extractResultList.length + '个'" :visible.sync="extractResultListDialog">

            <template>
                <el-table
                        border
                        stripe
                        :data="extractResultList"
                        :height="tableMaxHeight"
                        class="bigScreenTable"
                        style="width: 100%">
                    <el-table-column
                            header-align="center"
                            label="序号"
                            width="80"
                            type="index"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="contractSignTime"
                            label="合同签署时间"
                            :show-overflow-tooltip="true"
                            align="center">
                        <template slot-scope="scope">
                            <span>{{formatDate(scope.row.contractSignTime,'yyyy-MM-dd HH:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="projectTypeName"
                            label="招标项目类型"
                            :show-overflow-tooltip="true"
                            align="center">
                    </el-table-column>
                </el-table>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="extractResultListDialog = false" type="primary">关 闭</el-button>
            </div>

        </el-dialog>

        <el-dialog width="80%" :title="'符合当前抽取条件的总数量为'+ total + '个'" :visible.sync="extractPondListDialog">

            <template>
                <el-table
                        border
                        :data="extractPondList"
                        :height="tableMaxHeight"
                        class="bigScreenTable"
                        style="width: 100%">
                    <el-table-column
                            header-align="center"
                            label="序号"
                            width="80"
                            type="index"
                            :index="getRowsIndex"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            v-if="historyid == -1"
                            :show-overflow-tooltip="true"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            :show-overflow-tooltip="true"
                            align="center"
                            label="项目名称"
                            prop="projectNameVisible"
                            v-if="historyid != -1">
                    </el-table-column>
                    <el-table-column
                            prop="contractSignTime"
                            label="合同签署时间"
                            :show-overflow-tooltip="true"
                            align="center">
                        <template slot-scope="scope">
                            <span>{{formatDate(scope.row.contractSignTime,'yyyy-MM-dd HH:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="projectTypeName"
                            label="招标项目类型"
                            :show-overflow-tooltip="true"
                            align="center">
                    </el-table-column>
                </el-table>
                <el-pagination background
                               layout="total, sizes, prev, pager, next"
                               :page-sizes="[10, 20, 50, 100]"
                               :popper-class="'bigScreenSelectPopper'"
                               :page-size="pageSize"
                               :total="total"
                               :current-page="pageIndex"
                               @size-change="sizeChangeHandle"
                               @current-change="currentChangeHandle"></el-pagination>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="extractPondListDialog = false" type="primary">关 闭</el-button>
            </div>

        </el-dialog>

        <el-dialog title="抽取条件" :visible.sync="extractFilterDialog">
            <template>
                <p v-if="form.ruleType == 1 || form.ruleType == 2" class="extractFilterWrapper">
                    项目抽取条件：从符合条件的总数中随机抽取
                    <span>{{form.extractRule}}</span>
                    <span>{{form.ruleType==1?"个":"%"}} 。</span>
                </p>
                <div v-if="form.ruleType == 3" style="display: flex" class="extractFilterWrapper">
                    <span style="vertical-align: top">项目抽取条件：</span>
                    <table class="role_table" style="width: calc(100% - 120px);">
                        <thead style="width: 100%;">
                            <th width="50%">
                                <span>{{formatterDataDictionary(extractNumberTypeList,form.ruleCompMethod)}}</span>
                            </th>
                            <th width="50%">
                                <span>{{form.numOrPercentType == '1'?'数量':'比例'}}</span>
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ruleList" :key="index">
                                <td>
                                    <p v-if="form.ruleCompMethod == '1'">
                                        <span>{{item.projectTypeName}}</span>
                                    </p>
                                    <p v-else-if="form.ruleCompMethod == '2'">
                                        介于 <span>{{item.currencyMin}}</span>万元 至 <span>{{item.currencyMax}}</span> 万元
                                    </p>
                                    <p v-else>
                                        <span>{{item.regionCodeName}}</span>
                                    </p>
                                </td>
                                <td>
                                    符合抽取条件总项目的
                                    <span>{{item.numOrPercent}}</span><span>{{form.numOrPercentType == '1'?'个':'%'}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="extractFilterDialog = false" type="primary">关 闭</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import vueSeamlessScroll from 'vue-seamless-scroll';

    export default {
        name: "step_three",
        components: {
            vueSeamlessScroll
        },
        props:{
            activeStep: {type: Number, default: 3},
            extractNum: {type: Number, default: 0},
            curStep: {type: Number, default: 3},
            historyid: {type: Number, default: -1},
            taskName: {type: String, default: ''},
            supervisionIdsName: {type: String, default: ''},
        },
        data(){
            return{
                id:"",
                stepLoading:false,
                cardMinHeight: document.documentElement.clientHeight - 640  + 'px',
                tableMaxHeight: document.documentElement.clientHeight - 400 ,
                extractIngFlag:false,
                defaultExtractPondList:[],
                defaultExtractPondListShuffle:[],
                extractPondList:[],
                extractResultListDialog:false,
                extractPondListDialog:false,
                extractFilterDialog:false,
                extractResultList:[],
                stepSpeed:0,
                ruleList:[],
                extractNumberTypeList:[],
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total:0,
                form:{
                    ruleType:1, // 抽取规则类型  1,2,3
                    extractRule:"",// 抽取规则
                    mathRule:1, // 小数位取整规则 1四舍五入 2向下取整 3向上取整
                    workName:"",
                    ruleCompMethod:'1',
                    ruleCompMethodName:"",
                    numOrPercentType:'1',
                    id:'',
                    taskId:"",
                    extractCode:"",
                    extractTime:"",
                    extractorName:"",
                },
            }
        },
        filters:{

        },
        created(){
            this.getDic('extract_number_type');
            this.form.taskId = this.$route.query.id || '';
            this.getExtractPondList();
            this.getExtractFilterById();
        },
        mounted(){


            this.$nextTick(()=>{
                if(this.historyid == -1){  // 还未抽取项目 查抽取池及给默认抽取结果赋值
                    this.getDefaultExtractPondList()
                }else{ // 获取抽取结果
                    this.getExtractResult()
                }
            })



        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            }),
            classOption() {
                return {
                    step: 10, // 数值越大速度滚动越快
                    limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: false, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: false, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
                }
            }
        },
        methods:{

            getDic(type) { // 获取字典
                this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'extract_number_type':this.extractNumberTypeList = res.data.data;break;
                            case '146':this.projectTypeList = res.data.data;break;
                        }
                    }
                })
            },

            getExtractFilterById(){

                if(this.form.taskId){
                    this.$httpReq.get('/projectDoubleExtract/extractfilter/getExtractFilter?extractTaskId='+this.form.taskId).then(res=>{
                        if(res.data.code == '1' && res.data.data ){
                            let resData = res.data.data;
                            this.form.ruleType = resData.ruleType;
                            this.form.extractRule = resData.extractRule;
                            if(resData.ruleType == 3){
                                let extractRule = JSON.parse(resData.extractRule);
                                this.form.ruleCompMethod = extractRule.ruleCompMethod;
                                this.form.numOrPercentType = extractRule.numOrPercentType;
                                this.ruleList = extractRule.ruleList;
                            }
                            this.formDataString = JSON.stringify(this.form);

                        }
                    })
                }

            },

            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1
                this.getExtractPondList()
            },
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getExtractPondList()

            },
            getRowsIndex(index){
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },

            getExtractPondList(){
                if(this.form.taskId){
                    this.$httpReq.post('/projectDoubleExtract/extractfilter/getExtractPool',{
                        'page': this.pageIndex,
                        'rows': this.pageSize,
                        'filter': {
                            taskId:this.form.taskId
                        }}).then(res=>{
                        this.extractPondList = res.data.rows;
                        this.total = res.data.total;
                    })

                }
            },
            getDefaultExtractPondList(){
                if(this.form.taskId){
                    this.$httpReq.post('/projectDoubleExtract/extractfilter/getExtractPool',{
                        'page': 1,
                        'rows': 200,
                        'filter': {
                            taskId:this.form.taskId
                        }}).then(res=>{
                            this.defaultExtractPondList = res.data.rows || [];
                            const _this = this;
                            setTimeout(()=>{
                                if(this.historyid == -1){ // 还未抽取项目，给抽取结果一个默认值方便展示在页面
                                    let extractPondList = JSON.parse(JSON.stringify(_this.defaultExtractPondList))
                                    if(extractPondList.length > _this.extractNum){
                                        _this.extractResultList = extractPondList.slice(0,_this.extractNum)
                                    }else{
                                        _this.extractResultList = extractPondList;
                                    }

                                }
                            },500)


                    })

                }
            },
            shuffle(arr){
                arr = JSON.parse(JSON.stringify(arr))
                var newArr = [];
                var len = arr.length;
                for(var i=0; i<len; i++){
                    var index = Math.floor(Math.random()*arr.length);//随机下标
                    newArr.push(arr[index]);//将随机出的元素，存放新数组newArr中去
                    arr.splice(index,1);//    将随机出的元素在arr中删除
                }
                //arr中删除随机出的元素,arr.length-1,同时i++,导致循环不会10次,会是5次.最后得到newArr中只有一半的随机数字,arr中剩下另一半. 将其合并到一起,得到res
                var res =[...newArr,...arr];
                return res
            },

            startExtract(){

                // this.stepSpeed = 20;
                // this.extractResultList = [];
                // this.extractIngFlag = true;
                this.defaultExtractPondListShuffle = this.shuffle(this.defaultExtractPondList);

                this.stepLoading = true;
                this.$httpReq.get('/projectDoubleExtract/extractfilter/startExtarct?extractTaskId='+this.form.taskId).then(res=>{
                    this.stepLoading = false;
                    if(res.data.code == '1' ){
                        this.stepSpeed = 20;
                        this.extractResultList = [];
                        this.extractIngFlag = true;
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getExtractResult(bool){

                this.$httpReq.get('/projectDoubleExtract/extractfilter/getExtractResult?extractTaskId='+this.form.taskId+'&changeStatus='+(bool?'1':'0')).then(res=>{
                    if(res.data.code == '1' ){
                        if(this.historyid == -1){ // 未抽取时获取抽取结果 即点击停止按钮获取抽取结果，此时需要滚动渐停展示抽取结果。
                            const _this = this;
                            var timer = setInterval(function(){
                                _this.stepSpeed = _this.stepSpeed-5;
                                if(_this.stepSpeed == 5){
                                    _this.extractIngFlag = false;
                                    _this.extractResultList = res.data.data || [];
                                }
                                if(_this.stepSpeed == 0){
                                    clearInterval(timer);
                                }
                            },200)
                            this.$emit("upDateTaskInfo")
                        }else{
                            this.extractResultList = res.data.data || [];
                        }

                    }
                })


            },
            showExtractResult(){
                this.extractResultListDialog = true;
            },

            prevStep(){
                this.$emit("update:activeStep",this.activeStep - 1)
            },
            nextStep(){

                this.$httpReq.get('/projectDoubleExtract/extracttask/updateCurStep?taskId='+this.form.taskId + '&curStep='+(this.activeStep + 1)).then(res=>{})
                this.$emit("update:activeStep",this.activeStep + 1)

            },


        },
    }
</script>

<style lang="scss" scoped>
    .step_content{
        .operation_wrapper{
            .extract_opt_wrapper{
                background: rgba(49, 150, 250, 0.1);
                padding: 8px 48px 32px 48px;
                position: relative;
               background-image: linear-gradient(rgba(49, 150, 250, 0.8),
               rgba(49, 150, 250, 0.2),
               rgba(49, 150, 250, 0.1),
               rgba(49, 150, 250, 0.1),
               rgba(49, 150, 250,0.1),
               rgba(49, 150, 250,0.1),
               rgba(49, 150, 250,0.1),
               rgba(49, 150, 250,0.1),
               rgba(49, 150, 250, 0.1),
               rgba(49, 150, 250, 0.1),
               rgba(49, 150, 250,0.1));
                .step_opt_title{
                    width: 800px;
                    height: 46px;
                    display: inline-block;
                    font-size: 24px;
                    font-weight: 600;
                    line-height: 32px;
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat 0px -260px;
                }

                .step_opt_icon {
                    width: 80px;
                    height: 80px;
                    position: absolute;
                    display: inline-block;
                }
                .border_opt_leftT {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -654px -161px;
                    left: 10px;
                    top: 10px;
                }

                .border_opt_rightT {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -708px -161px;
                    right: 10px;
                    top: 10px;
                }

                .border_opt_leftB {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -814px -239px;
                    left: 10px;
                    bottom: 10px;
                }

                .border_opt_rightB {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -787px -160px;
                    right: 10px;
                    bottom: 10px;
                }
                .extract_info{
                    display: inline-block;
                    position: absolute;
                }
                .extract_info_left{
                    left:20px;
                    top:24px;

                }
                .extract_info_right{
                    right:20px;
                    top:24px;
                }


                .seamless-warp{
                    height:36px;
                    overflow: hidden;
                    background: url(../../../../assets/img/bigScreen/border.png);
                    background-size:100% 100%;
                    border: none;
                    p{
                        padding: 0;margin: 0;
                        line-height: 36px;
                    }

                }


            }

        }

        /deep/ .extractFilterWrapper{
            color: #FFFFFF;
        }
    }






</style>